'use client';

import { useTranslations } from 'next-intl';
import { useCustomer } from '@cobrastyle/storefront-core/hooks';
import { StoreLink } from '@/components/store';

export function AccountButton() {
  const t = useTranslations('nav');
  const { customer, isLoggedIn } = useCustomer();

  if (isLoggedIn && customer) {
    return (
      <StoreLink
        href="/konto"
        className="text-[13px] font-medium text-foreground transition-colors hover:text-accent-foreground"
        title={t('account')}
      >
        <span>
          {customer.firstname}
        </span>
      </StoreLink>
    );
  }

  return (
    <StoreLink
      href="/konto/logga-in"
      className="text-[13px] font-medium text-foreground transition-colors hover:text-accent-foreground"
      title={t('signIn')}
    >
      <span>
        {t('signIn')}
      </span>
    </StoreLink>
  );
}
